import { useEffect } from "react";
import { Button, HStack } from "@chakra-ui/react";
import { EFiltersAliasState, useOperationListFiltersStore } from "../../../../store/operationListFiltersStore";

export function OperationsPageFilters() {
  const filterAlias = useOperationListFiltersStore(state => state.filterAlias);
  const setFilter = useOperationListFiltersStore(state => state.setFilter);
  const resetFilter = useOperationListFiltersStore(state => state.reset);

  const onClick = (newFilter: EFiltersAliasState) => () => {
    setFilter(newFilter);
  };

  const getStyle = (operationType: EFiltersAliasState): { scheme: "brand" | "gray"; color: string } => {
    return filterAlias === operationType
      ? { scheme: "brand", color: "white" }
      : { scheme: "gray", color: "gray.600" };
  };

  useEffect(() => {
    return () => {
      resetFilter();
    };
  }, []);

  return (
    <HStack py="15px">
      <Button
        onClick={onClick(EFiltersAliasState.Outflows)}
        color={getStyle(EFiltersAliasState.Outflows).color}
        colorScheme={getStyle(EFiltersAliasState.Outflows).scheme}
        h="40px"
        pt="2px"
        flex="1"
        fontSize="sm"
        borderRadius="full"
      >
        Траты
      </Button>
      <Button
        onClick={onClick(EFiltersAliasState.Inflows)}
        color={getStyle(EFiltersAliasState.Inflows).color}
        colorScheme={getStyle(EFiltersAliasState.Inflows).scheme}
        h="40px"
        pt="2px"
        flex="1"
        fontSize="sm"
        borderRadius="full"
      >
        Поступления
      </Button>
    </HStack>
  );
}
